import script from "./realtimeMonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./realtimeMonitor.vue?vue&type=script&setup=true&lang=js"

import "./realtimeMonitor.vue?vue&type=style&index=0&id=6b8c7dea&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b8c7dea"]])

export default __exports__